enum ServicesFormArea {
    CivilStateDeceasedPartner = 'civil-state-change',
    CivilStateMarriagePartnership = 'civil-state-change-marriage-registered-partnership',
    ChangeOfAddress = 'change-of-address',
    ChangeOfAccount = 'change-of-account',
}

export default ServicesFormArea;
